import React, { useCallback } from 'react';
import { UserActivityCategory, UserActivityTypes } from '@pascal/iframe-service';

import { JackpotModule } from '../../../../jackpot/modules/jackpotModule';
import { AspectRatioImage } from '../cashback/ratio-image';
import { JackpotWinPopup } from './jackpot-win-popup';
import { JackpotDetails } from './jackpot-details';
import { JackpotTiers } from './jackpot-tiers';
import { isMobile } from '../../../../helpers';
import { useStore } from '../../../../hooks';
import { observer } from 'mobx-react-lite';

import './scss/jackpot-header.scss';
import './scss/popup.scss';
import './scss/jackpot.scss'

interface JackpotProps {

}

export const Jackpot: React.FC<JackpotProps> = observer(() => {

  const { jackpotStore, gameStore, userActivityStore } = useStore();
  const { gameReady, canvasWidth } = gameStore;
  const { winPopupData, openJackpotScene, isShowJackpotCongratsPopUp, jackpotDetailsOpen } = jackpotStore;
  const openJackpot = openJackpotScene || isShowJackpotCongratsPopUp

  const toggleJackpotDetailsOpen = useCallback(() => {
    userActivityStore.sendTrackUserActivity({
      category: UserActivityCategory.PromoTools,
      type: UserActivityTypes.JackpotWidget
    });
    jackpotStore.setJackpotDetailsOpen(!jackpotDetailsOpen);
  }, [jackpotDetailsOpen]);

  const toggleJackpotDetailsClose = useCallback(() => {
    jackpotStore.setJackpotDetailsOpen(!jackpotDetailsOpen);
  }, [jackpotDetailsOpen]);

  if (!gameReady) return null;

  const isWebWithCanvas = !isMobile() && !!canvasWidth;

  const content = (
    <>
      <div
        style={isWebWithCanvas ? { maxWidth: canvasWidth } : {}}
        className={`jackpot-widget ${jackpotDetailsOpen ? 'open-jackpot-widget' : ''}`}
      >
        <AspectRatioImage />
        <JackpotTiers
          canvasWidth={canvasWidth}
          isWebWithCanvas={isWebWithCanvas}
          onTierClick={toggleJackpotDetailsOpen}
        />
        {
          jackpotDetailsOpen && (
            <JackpotDetails onClose={toggleJackpotDetailsClose} />
          )
        }
      </div>
      {
        winPopupData ? (
          <JackpotWinPopup />
        ) : null
      }
      {
        openJackpot && (
          <div className="jackpot-wrapper">
            <JackpotModule />
          </div>
        )
      }
    </>
  );

  if (isWebWithCanvas) {
    return <div className="is-mobile jackpot-canvas-mobile">{content}</div>;
  }

  return content;
});
